import * as Linking from "expo-linking";

const operatorScreens = {
  TablesRoot: {
    path: "",
    screens: {
      Tables: {
        path: "",
      },
      TableDetails: {
        path: ":tableId",
      },
    },
  },

  GamingRoot: {
    path: "operator-gaming",
    screens: {
      Gaming: {
        path: "",
      },
      GamingDetails: {
        path: ":computerId",
      },
    },
  },

  VRRoot: {
    path: "operator-vr",
    screens: {
      VRGaming: {
        path: "",
      },
      VRGamingDetails: {
        path: ":computerId",
      },
    },
  },

  OperatorBenefits: {
    path: "operator-benefits",
  },

  OperatorSettingsRoot: {
    path: "operator-settings",
    screens: {
      OperatorSettings: {
        path: "",
      },
      OperatorSettingsLightsAndColors: {
        path: "lights&colors",
      },
      OperatorSettingsReceipts: {
        path: "receipts",
      },
      OperatorSettingsProfile: {
        path: "profile",
      },
      OperatorSettingsSummary: {
        path: "summary",
      },
      OperatorSettingsReport: {
        path: "report",
      },
      OperatorSettingsInvoices: {
        path: "invoices",
      },
      InvoicePreview: {
        path: "invoice-preview/:dateFrom/:invoiceFile",
      },
      Suppliers: {
        path: "suppliers",
      },
      Inventory: {
        path: "inventory",
      },
      InventoryCheckpoints: {
        path: "inventory-checkpoints",
      },
      OperatorCategories: {
        path: "categories",
      },
      OperatorProducts: {
        path: "products",
      },
      OperatorSettingsInvite: {
        path: "invite",
      },
      Designer: {
        path: "designer",
      },
      OperatorSettingsOperators: {
        path: "operators",
      },
      SalesCharts: {
        path: "sales-charts",
      },
      OperatorSettingsPasskeys: {
        path: "passkeys",
      },
      CashRegister: {
        path: "cash-register",
      },
      OperatorSettingsKioskDevices: {
        path: "kiosk-devices",
      },
      OperatorSettingsThemeDesigner: {
        path: "theme-designer",
      },
    },
  },

  Orders: {
    path: "orders",
    screens: {
      Orders: "orders",
    },
  },
  DeliveriesRoot: {
    path: "deliveries",
    screens: {
      Deliveries: "",
      DeliveryDetails: {
        path: ":deliveryId",
      },
    },
  },
};

const linking = {
  prefixes: [
    Linking.createURL("/"),
    "harlem://",
    "exp://harlem-local.refractionx.com:19000/--/",
  ],
  config: {
    screens: {
      Root: {
        path: "",
        screens: {
          Landing: {
            path: "",
          },
          MenuRoot: {
            path: "menu",
            screens: {
              Menu: {
                path: "",
              },
              PublicTable: {
                path: "tables/:tableId/token/:tableToken",
              },
              PublicComputer: {
                path: "computers/:computerId/token/:computerToken",
              },
            },
          },
          VR: {
            path: "vr",
          },
          Esports: {
            path: "esports",
          },
          More: {
            path: "more",
          },
          OnlineOrder: {
            path: "order",
          },
        },
      },
      PublicInvite: {
        path: "invite/:token"
      },
      PublicTableCode: {
        path: "tables/:tableNumber/:tableCode",
      },
      OnlineOrderStatus: {
        path: "order/:orderId/token/:publicToken",
      },
      KioskOrder: {
        path: "kiosk",
      },
      OrdersRoot: {
        path: "orders",
        screens: {
          Orders: "orders",
        },
      },
      DeliveriesRoot: {
        path: "deliveries",
        screens: {
          Deliveries: "deliveries",
        },
      },
      OperatorRoot: {
        path: "magia",
        screens: operatorScreens,
      },
      LegacyOperatorRoot: {
        path: "tables",
        screens: operatorScreens,
      },
      LegalTerms: "terms",
      LegalRefund: "refund-policy",
      LegalDelivery: "delivery-terms",
      QRCodeModal: "qr/tables/:tableNumber/:tableCode",
      QRCodeModalLegacy: "qr/tables/:tableId/token/:tableToken",
      QRCodeModalPC: "qr/computers/:computerId/token/:computerToken",
      NotFound: "*",
    },
  },
};

export default linking;
